import script from "./sivPage.vue?vue&type=script&setup=true&lang=js"
export * from "./sivPage.vue?vue&type=script&setup=true&lang=js"

import "./sivPage.vue?vue&type=style&index=0&id=6d0c6874&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d0c6874"]])

export default __exports__